






































import Vue, {VueConstructor} from 'vue'
import uiTableTree from '@/components/Ui/TableTree/TableTree.vue'
import ActionsDropdown from '@/components/Ui/ActionsDropdown/ActionsDropdown.vue'
import {ActiveTableTreeConfig} from '@/components/Ui/ActiveTableTree/core/ActiveTableTree'
import _ from 'lodash'
export default (Vue as VueConstructor<Vue & {
}>).extend({
  name: 'ActiveTableTree',
  components: {uiTableTree, ActionsDropdown},
  props: {
    data: {
      type: Array as () => any[],
      default: () => []
    },
    config: Object as () => ActiveTableTreeConfig,
    showActions: {
      type: Boolean,
      default: true
    },
    gridTemplateColumns: String,
    nodeIndent: {
      type: Number,
      default: 36
    },
    defaultExpandedKeys: {
      type: Array as () => string[],
      default: () => []
    }
  },
  methods: {
    onReload (): void {
      this.$emit('onReload')
    },
    onActionsError (error: any): void {
      this.$emit('actions-error', error)
    },
    onNodeClick (event: any) {
      if (this.config.onNodeClick) {
        this.config.onNodeClick(event);
      }
    },
    onNodeExpand (event: any) {
      this.$emit('node-expand', event)
    },
    onNodeCollapse (event: any) {
      this.$emit('node-collapse', event)
    }
  },
  computed: {
    cols (): any {
      if (!this.config.tree.cols) {
        console.error('TableTree cols are undefined!')
        return {}
      }

      let cols = _.cloneDeep(this.config.tree.cols);
      if (this.config.actions && this.showActions) {
        // @ts-ignore
        cols._actions = {label: this.$t('labels.actions')}
      }
      if (this.config.detailButton) {
        // @ts-ignore
        cols._detailButton = {label: this.$t('labels.more')}
      }
      return cols;
    }
  }
})
